import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FireBaseObjectNames,LocalStorageCodes } from '../../../core/codes';
import { AppSettings } from '../../../config/app-settings';
import { Storage } from '@ionic/storage';
import { ElasticSearchService, ElasticResult } from '../../../providers/elastic-search';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
import { HaversineService, GeoCoord  } from "ng2-haversine";
import { Http } from '@angular/http';
import _ from 'lodash';
import 'rxjs/add/operator/combineAll';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/fromPromise';
@Injectable()
export class StoreLocatorData {
    private elasticIndex: string;
    private elasticType: string;
    private elasticPath: string;
    private gMapRadius: number;
    private geoCodeUrl: string;
    constructor(
        public settings: AppSettings,
        private storage: Storage,
        private http: Http,
        private elasticSearchService : ElasticSearchService,
        private haversineService: HaversineService,
        public afw: AngularFireDatabaseWrapper
        ) {
        if(!this.settings.elasticSearch ||  !this.settings.elasticSearch.stores || !this.settings.elasticSearch.stores.index){
            this.settings.getData().subscribe(sets=>{
                this.elasticIndex = sets.elasticSearch.stores.index; 
                this.elasticType = sets.elasticSearch.stores.type; 
                this.elasticPath = sets.elasticSearch.stores.path; 
                this.gMapRadius = sets.gMapRadius;
                this.geoCodeUrl = sets.geoCodeUrl;
            })
        }
        else{
            this.elasticIndex = this.settings.elasticSearch.stores.index; 
            this.elasticType = this.settings.elasticSearch.stores.type; 
            this.elasticPath = this.settings.elasticSearch.stores.path; 
            this.gMapRadius = this.settings.gMapRadius;
            this.geoCodeUrl = this.settings.geoCodeUrl;
        }
        
    }

    public getStore(storeId){
		let strgRef = '/' + FireBaseObjectNames.STORELOCATOR + '/' + storeId ;
        return this.afw.object(strgRef).take(1).map(val=>{
			return val;
		});
	}

    public getAllStores(){
        let strgRef = '/' + FireBaseObjectNames.STORELOCATOR;
        return this.afw.object(strgRef,undefined,true).map(val=>{
			return val;
		});
    }

    public getAll(){
        var query: any = {
            index: this.elasticIndex,
            type: this.elasticType,
            size: 5000
        };

        query.body= {};
        query.body.query = {
            bool:{
                must:{
                    match_all : {}
                },
                must_not:[{
                     match : {
                        isDeleted: true,
                     }
                },{
                     match : {
                        active: false,
                     }
                }]
            }
        };
        return this.elasticSearchService.Search(query,this.elasticPath,true);
    }

    public getStoreByStoreNumber(storeNumber:string){
        var query:any = {
            index: this.elasticIndex,
            type: this.elasticType,
            size: 5000
        };

        query.body= {};
        query.body.query = {
            bool:{
                must:{
                    match : {
                        storeNumber: storeNumber,
                     }
                },
                must_not:[{
                     match : {
                        isDeleted: true,
                     }
                },{
                     match : {
                        active: false,
                     }
                }]
            }
        };
  
        return this.elasticSearchService.Search(query,this.elasticPath,true).map((result:ElasticResult) => {
            return result.items.length > 0 ? result.items[0] :  null;
        });
    }

    public getStoreByZipCode(zipCode: string){
        var zip = parseInt(zipCode);
        var query:any = {
            index: this.elasticIndex,
            type: this.elasticType,
            size: 5000
        };

        query.body= {};
        query.body.query = {
            bool:{
                must:{
                    match : {
                        zipCode: zip,
                     }
                },
                must_not:[{
                     match : {
                        isDeleted: true,
                     }
                },{
                     match : {
                        active: false,
                     }
                }]
            }
        };
        return this.elasticSearchService.Search(query,this.elasticPath,true);
    }

     public getStoreByCity(city : string){
        var query:any = {
            index: this.elasticIndex,
            type: this.elasticType,
            size: 5000
        };

        query.body= {};
        query.body.query = {
            bool:{
                must:{
                    match_phrase_prefix: {
                        city : city
                    }
                },
                must_not:[{
                     match : {
                        isDeleted: true,
                     }
                },{
                     match : {
                        active: false,
                     }
                }]
            }
        };
        return this.elasticSearchService.Search(query,this.elasticPath,true);
    }

    public getStoreByCoords(latlng: string, radius?: number){
        // var result = [];
        if(!radius){
            radius = this.gMapRadius;
        }
        return this.getAll().map((stores:ElasticResult) => {
            let values = latlng.split(',');
            if(values.length === 2 && stores.items != null && stores.items.length > 0){
                 let lat = parseFloat(values[0]);
                 let lng = parseFloat(values[1]);
                 return _.filter(stores.items, (store) =>{
                    if(!store.latitude || !store.longitude){
                        return false;
                    }
                    let miles = this.getDistance(lat,lng,store.latitude, store.longitude);
                    store.distance = miles;
                    return miles <= radius;
                });
            }else{
                return [];
            }
        });
    }


    public GetCoordFromAddress(address){
        return this.http.get(this.geoCodeUrl + address).map((data:any) => {
            if(data.statusText !== 'OK'  || data.status != 200){
                 return [];
            }
           
            let xml = data['_body'];
            var parser = new DOMParser();
            let xmlDoc = parser.parseFromString(xml, "application/xml");
            let locationNodes = xmlDoc.getElementsByTagName("location");
            if(locationNodes.length == 0){
                return [];
            }
            return _.map(locationNodes,(location) => {
                if(location.children){
                    let latNode = location.children[0].innerHTML;
                    let lngNode = location.children[1].innerHTML;
                    if (latNode && lngNode)
                    {
                        return latNode  + "," + lngNode;
                    }
                }
            })
        },error => {
            return [];
        });
    }


    public searchStore(keyword: string, sort: string = 'city'){
        keyword = keyword.trim() || '';
        let matchZip  = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(keyword);
        if(keyword === ''){
            return this.getAll().map((res:ElasticResult) => {
                var stores = res.items || [];
                return this.sortStores(stores,keyword,sort);
            }).mergeAll();
        }else{
            return this.getStoreByStoreNumber(keyword).map((res:any) => {
                var store = res || null;
                if(store){
                   return this.sortStores([store],keyword,sort);
                }else if(matchZip == true){
                   return this.searchStoreByZipCode(keyword,this.gMapRadius).map((data:Array<any>) =>{
                        var stores = data || [];
                        return this.sortStores(stores,keyword,sort);
                   }).mergeAll();
                }else{
                   return this.searchStoreByCity(keyword,this.gMapRadius).map((data:Array<any>) =>{
                        var stores = data || [];
                        return this.sortStores(stores,keyword,sort);
                   }).mergeAll();
                }
            }).mergeAll();
        }
    }

    private sortStores(stores,keyword,sort){
        // get distance with user location
        return this.setUserDistance(stores).map((res:any) =>{
            if(keyword.trim() === ''){
                if(sort && sort.trim() === 'city'){
                    res = res.sort((a,b) => b.city - a.city);
                }else if(sort && sort.trim() === 'distance'){
                    res = res.sort((a,b) => b.distance - a.distance);
                }else{
                    res = res.sort((a,b) => b.storeNumber - a.storeNumber);
                }
            }else{
                res = res.sort((a,b) => b.distance - a.distance);
            }
            
            return res;
        });
    }

    public searchStoreByZipCode(keyword: string, radius: number){
        let srcs = [];
        srcs.push(this.getStoreByZipCode(keyword)
            .map((res:ElasticResult)=>{
                return res.items || [];
            })
        );
        srcs.push(this.GetCoordFromAddress(keyword).map(cords=>{
            return this.getStoreByCoords(cords[0]);
        }).mergeAll());

        return Observable.from(srcs)
        .combineAll()
        .map((res:Array<any>)=>{
            var items = _.uniqBy(_.flatMap(res),'$key');
            return items;
        });
    }

    public searchStoreByCity(keyword: string, radius: number){
        let city = keyword.replace(/[^a-zA-Z0-9]/g,'');
        let address = city + ",US";
        let srcs = [];
        srcs.push(this.getStoreByCity(city)
            .map((res:ElasticResult)=>{
                return res.items || [];
            })
        );
        srcs.push(this.GetCoordFromAddress(address).map(cords=>{
            return this.getStoreByCoords(cords[0]);
        }).mergeAll());

        return Observable.from(srcs)
        .combineAll()
        .map((res:Array<any>)=>{
            var items = _.uniqBy(_.flatMap(res),'$key');
            return items;
        });
    }

    public getDistance(lat1,lng1,lat2,lng2){
        let geo1 : GeoCoord = {
            latitude: parseFloat(lat1),
            longitude: parseFloat(lng1)
        };

        let geo2 : GeoCoord = {
            latitude: parseFloat(lat2),
            longitude: parseFloat(lng2)
        };

        return this.haversineService.getDistanceInMiles(geo1, geo2);
    }

    public getCurrentPosition(){
         return Observable.create((observer) => {
             navigator.geolocation.getCurrentPosition((position) =>{
                 observer.next({latitude: position.coords.latitude, longitude: position.coords.longitude});
             },error =>{
                 console.log(error);
                 observer.next(null);
             });
         })
    }

    private setUserDistance(stores){
        return this.getCurrentPosition().map((res:any) =>{
            if(res){
                _.forEach(stores, store => {
                    let miles = this.getDistance(res.latitude,res.longitude,store.latitude, store.longitude);
                    store.distance = miles;
                })
            }
            return stores;
        });
    }


    /**/
    public setCurrentStore(store) {
        this.getStore(store.$key).subscribe(fullStore=>{
            let storeInfo: any;
            if(fullStore){
                storeInfo = fullStore;
                storeInfo.$id = fullStore.$key;
            }else{
                storeInfo = store;
                storeInfo.$id = store.$key;
            }
            this.storage.set(LocalStorageCodes.CURRENT_STORE, JSON.stringify(storeInfo));
        });
    }

    public getCurrentStore() {
        return Observable.create((observer) => {
            this.storage.get(LocalStorageCodes.CURRENT_STORE).then((value) => {
                observer.next(value ? JSON.parse(value) : null);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/modules/store-locator/providers/store-locator-data.ts